module.exports = "/_next/static/images/d7fcc00f24714881190fcb5eba05e034-yield-lg.png";